import { ActionTypes } from '../actions/CountryCodesActions';
// import Helpers         from 'app/utils/helpers/Helpers';

var initial_state = [];

var callables = {

	[ActionTypes.update_countryCodes](state, action) {
		return action.countryCodes;
	}
};

export default function(state = initial_state, action) {

	if (callables.hasOwnProperty(action.type)) {
		return callables[action.type](state, action);
	}

	return state;
};